type Circle = {
  fill: string
  width: string
  height: string
  title: string
}

function ShapeOval(props: Circle) {
  const fill = props.fill || 'currentColor'
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'shape oval'

  return (
    <svg
      height={height}
      width={width}
      viewBox='0 0 48 48'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <g fill={fill}>
        <path
          d='M24,2A22,22,0,1,0,46,24,22.025,22.025,0,0,0,24,2Z'
          fill={fill}
        />
      </g>
    </svg>
  )
}

export default ShapeOval
